import * as React from "react";
function useDidUpdateEffect(callback, deps) {
  const didMountRef = React.useRef(false);
  return React.useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return void 0;
    }
    return callback();
  }, deps);
}
export {
  useDidUpdateEffect
};
//# sourceMappingURL=useDidUpdateEffect.js.map
